import styled from '@emotion/styled'

export const PackageSection = styled.section`
  padding: 24px 20px;
  margin-bottom: 20px;
  color: white;
  background: #202327;
`

export const FoodSectionHeader = styled.header`
  max-width: 720px;

  > span {
    color: #ff8e00;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  h2 {
    margin: 5px 0 6px;
    font-size: 25px;
  }

  p {
    margin: 0;
    color: #b7c1d3;
    line-height: 1.5;
  }
`

export const Recommendation = styled.div<{ complete?: boolean }>`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 13px;
  align-items: center;
  padding: 14px 16px;
  border: 1px solid
    ${({ complete }) => (complete ? '#3aa981' : 'rgba(255, 142, 0, 0.55)')};
  border-radius: 10px;
  margin-top: 18px;
  background: ${({ complete }) =>
    complete
      ? 'linear-gradient(135deg, rgba(27, 122, 91, 0.28), rgba(32, 37, 46, 0.9))'
      : 'linear-gradient(135deg, rgba(255, 142, 0, 0.17), rgba(32, 37, 46, 0.9))'};

  strong,
  span {
    display: block;
  }

  span {
    margin-top: 3px;
    color: #c0c8d5;
    font-size: 12px;
  }

  @media screen and (max-width: 560px) {
    grid-template-columns: auto 1fr;
  }
`

export const RecommendationIcon = styled.span<{ complete?: boolean }>`
  display: flex !important;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background: ${({ complete }) => (complete ? '#27936f' : '#ff8e00')};

  &::after {
    width: ${({ complete }) => (complete ? '7px' : '4px')};
    height: ${({ complete }) => (complete ? '13px' : '15px')};
    border-right: 3px solid #fff;
    border-bottom: ${({ complete }) =>
      complete ? '3px solid #fff' : '0 solid transparent'};
    content: '';
    transform: ${({ complete }) =>
      complete ? 'rotate(45deg) translate(-1px, -1px)' : 'none'};
  }
`

export const RecommendationCount = styled.strong`
  min-width: 58px;
  padding: 7px 9px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.22);
  font-size: 14px;
  text-align: center;

  @media screen and (max-width: 560px) {
    grid-column: 2;
    justify-self: start;
  }
`

export const OrderGroup = styled.div`
  margin-top: 30px;
`

export const ExtraOrderGroup = styled.details`
  margin-top: 30px;
  border: 1px solid #414856;
  border-radius: 10px;
  background: #292f39;

  &[open] {
    padding-bottom: 14px;
  }
`

export const ExtraOrderSummary = styled.summary`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
  list-style: none;

  &::-webkit-details-marker {
    display: none;
  }

  &::after {
    color: #ffb24d;
    content: '+';
    font-size: 26px;
    line-height: 1;
  }

  details[open] > &::after {
    content: '−';
  }

  h3 {
    margin: 3px 0 0;
    font-size: 18px;
  }

  span,
  small {
    display: block;
  }

  span {
    color: #8f9aab;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  small {
    color: #b7c1d3;
    text-align: right;
  }

  @media screen and (max-width: 560px) {
    align-items: flex-start;

    small {
      text-align: left;
    }
  }
`

export const ExtraOrderContent = styled.div`
  padding: 0 14px;
`

export const OrderGroupHeader = styled.div`
  display: flex;
  margin-bottom: 12px;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;

  span {
    color: #8f9aab;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  h3 {
    margin: 3px 0 0;
    color: #fff;
    font-size: 18px;
  }

  small {
    color: #8f9aab;
    text-align: right;
  }

  @media screen and (max-width: 560px) {
    align-items: flex-start;
    flex-direction: column;

    small {
      text-align: left;
    }
  }
`

export const OrderList = styled.div<{ featured?: boolean }>`
  display: grid;
  grid-template-columns: ${({ featured }) =>
    featured ? 'repeat(3, minmax(0, 1fr))' : 'repeat(2, minmax(0, 1fr))'};
  gap: 12px;

  @media screen and (max-width: 920px) {
    grid-template-columns: ${({ featured }) =>
      featured ? '1fr' : 'repeat(2, minmax(0, 1fr))'};
  }

  @media screen and (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`

export const OrderRow = styled.article<{
  featured?: boolean
  selected?: boolean
}>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 13px;
  padding: ${({ featured }) => (featured ? '0 14px 14px' : '14px')};
  border: 2px solid ${({ selected }) => (selected ? '#7b67ff' : '#414856')};
  border-radius: 10px;
  align-content: start;
  background: ${({ selected }) =>
    selected
      ? 'linear-gradient(145deg, rgba(83, 59, 255, 0.2), #292f39 55%)'
      : '#292f39'};
  box-shadow: ${({ selected }) =>
    selected ? '0 10px 24px rgba(0, 0, 0, 0.2)' : 'none'};
  overflow: hidden;
  transition:
    border-color 150ms ease,
    transform 150ms ease;

  &:hover {
    border-color: ${({ selected }) => (selected ? '#9b8cff' : '#5d6676')};
    transform: translateY(-1px);
  }
`

export const OrderImage = styled.img`
  width: calc(100% + 28px);
  height: 145px;
  margin: 0 -14px;
  grid-column: 1 / -1;
  object-fit: cover;
`

export const OrderDetails = styled.div`
  min-width: 0;
  grid-column: 1 / -1;

  > span {
    display: inline-block;
    padding: 3px 7px;
    border-radius: 10px;
    margin-bottom: 7px;
    color: #e5e0ff;
    background: rgba(83, 59, 255, 0.35);
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
  }

  strong,
  small {
    display: block;
  }

  > strong {
    font-size: 15px;
    line-height: 1.35;
  }

  small {
    margin-top: 5px;
    color: #aeb7c7;
    font-size: 11px;
    line-height: 1.45;
  }
`

export const QuantityControl = styled.div`
  display: flex;
  min-width: 112px;
  height: 38px;
  border: 1px solid #596170;
  border-radius: 7px;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  background: #1d2128;

  > strong {
    min-width: 20px;
    color: #fff;
    text-align: center;
  }
`

export const QuantityButton = styled.button`
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 5px;
  color: #fff;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 22px;
  line-height: 1;

  &:hover:not(:disabled),
  &:focus-visible {
    outline: none;
    background: #533bff;
  }

  &:disabled {
    color: #596170;
    cursor: not-allowed;
  }
`

export const OrderPrice = styled.div`
  align-self: end;

  small,
  strong {
    display: block;
  }

  small {
    color: #8f9aab;
    font-size: 10px;
  }

  strong {
    margin-top: 2px;
    color: #ffb24d;
    font-size: 15px;
  }
`

export const OrderTotal = styled.span`
  position: absolute;
  top: 9px;
  right: 9px;
  padding: 5px 8px;
  border-radius: 12px;
  color: #fff;
  background: rgba(17, 21, 28, 0.88);
  font-size: 10px;

  strong {
    margin-left: 3px;
    color: #ffb24d;
  }
`

export const ChoiceList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  @media screen and (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

export const ChoiceCard = styled.label<{ selected?: boolean }>`
  display: flex;
  min-height: 74px;
  padding: 13px;
  border: 2px solid ${({ selected }) => (selected ? '#7b67ff' : '#414856')};
  border-radius: 10px;
  align-items: center;
  gap: 10px;
  background: ${({ selected }) =>
    selected ? 'rgba(83, 59, 255, 0.2)' : '#292f39'};
  cursor: pointer;

  input {
    accent-color: #ff8e00;
  }

  strong,
  small {
    display: block;
  }

  small {
    margin-top: 4px;
    color: #b7c1d3;
  }
`

export const OptionImage = styled.img`
  width: 58px;
  height: 58px;
  border-radius: 7px;
  object-fit: cover;
`

export const SelectionStatus = styled.div<{ complete?: boolean }>`
  padding: 10px 12px;
  border: 1px solid ${({ complete }) => (complete ? '#3aa981' : '#c67b21')};
  border-radius: 8px;
  margin: 12px 0;
  color: ${({ complete }) => (complete ? '#8de0c2' : '#ffd08d')};
  background: ${({ complete }) =>
    complete ? 'rgba(39, 147, 111, 0.12)' : 'rgba(198, 123, 33, 0.12)'};
  font-size: 13px;
`

export const InfoPanel = styled.div`
  padding: 14px;
  border-left: 3px solid #7b67ff;
  margin-top: 30px;
  color: #c0c8d5;
  background: #292f39;

  a {
    margin-left: 6px;
    color: #ffb24d;
  }
`
